export const checkCountries = (dataObject, allCountries) => {
  let errorFlag = false;
  const arrStates = [];
  dataObject.forEach((d, i) => {
    if (d.country !== "") {
      let country = allCountries.find((c) => c.name.toUpperCase() === d.country.toUpperCase().replace(/\s+/g, " "));
      if (!country) {
        dataObject[i]["countryerr"] = true;
        dataObject[i]["stateerr"] = true;
        dataObject[i].country = "";
        dataObject[i].state = "";
        errorFlag = true;
      } else if (!arrStates.find((s) => s.countryName === country.name)) {
        dataObject[i].country = country.name;
        arrStates.push({ countryName: country.name, countryCode: country.iso2CountryCode, states: [] });
      } else dataObject[i].country = country.name;
    } else dataObject[i].state = "";
  });
  return [dataObject, arrStates, errorFlag];
};

export const checkStates = (dataObject, allStates, errorFlag) => {
  dataObject.forEach((d, i) => {
    if (d.country !== "" && !d.countryerr && d.state !== "") {
      let statesList = allStates.find((s) => s.countryName.toUpperCase() === d.country.toUpperCase().replace(/\s+/g, " "));
      if (statesList.states.length > 0) {
        let state = statesList.states.find((s) => s.toUpperCase() === d.state.toUpperCase().replace(/\s+/g, " "));
        if (!state) {
          dataObject[i]["stateerr"] = true;
          dataObject[i].state = "";
          errorFlag = true;
        } else dataObject[i].state = state;
      } else {
        dataObject[i].state = "";
      }
    }
  });
  return [errorFlag, dataObject];
};
